import { Component } from '@angular/core';
import { CrmAppComponent } from '@touch4it/ng-swp/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  imports: [CrmAppComponent],
})
export class AppComponent {}
